export default __webpack_public_path__ + "static/media/19.abe7d4c1.svg";